// extracted by mini-css-extract-plugin
export default {"examSetupForm":"_ExamSetupForm_examSetupForm__BwcS4"};